import { getServices } from "../getServices";

export const fetchKernel = async (
  id: number | null,
  username: string | null,
  slug: string | null
) => {
  if (!id && !(username && slug)) {
    throw new Error("Invalid argument.");
  }
  const kernel = await getServices().kernelsClient.getKernel({
    kernelId: id,
    username: username || "",
    slug: slug || "",
  });
  if (!kernel || !kernel.id) {
    throw new Error("An error occurred getting the kernel. No kernel id.");
  }
  return kernel;
};
